var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatistic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.994 59.994",
    style: {
      enableBackground: "new 0 0 59.994 59.994"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.921,27.926C58.908,13.061,46.934,1.086,32.068,0.072L31,0v28.994h28.994L59.921,27.926z M33,26.994V2.161   c2.448,0.262,4.805,0.844,7.026,1.702C40.02,3.908,40,3.948,40,3.994c0,0.552,0.448,1,1,1c0.312,0,0.58-0.152,0.763-0.376   c5.981,2.791,10.822,7.632,13.613,13.613C55.152,18.415,55,18.682,55,18.994c0,0.552,0.448,1,1,1c0.046,0,0.086-0.02,0.131-0.026   c0.858,2.222,1.44,4.578,1.702,7.026H33z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.338,51.091l0.706-0.766c4.618-5.008,7.416-11.494,7.877-18.263l0.073-1.068H31.242L51.338,51.091z M44,32.994h6h6   h1.833c-0.225,2.092-0.689,4.147-1.373,6.126c-0.139-0.073-0.291-0.126-0.459-0.126c-0.552,0-1,0.448-1,1   c0,0.464,0.322,0.837,0.751,0.95c-1.114,2.615-2.621,5.066-4.485,7.247l-1.208-1.208C50.582,46.951,51,46.526,51,45.994   c0-0.552-0.448-1-1-1c-0.532,0-0.957,0.418-0.988,0.942l-1.953-1.954C47.582,43.951,48,43.526,48,42.994c0-0.552-0.448-1-1-1   c-0.532,0-0.956,0.418-0.988,0.942l-1.953-1.953C44.582,40.95,45,40.526,45,39.994c0-0.552-0.448-1-1-1   c-0.532,0-0.956,0.418-0.988,0.942l-1.953-1.953C41.582,37.95,42,37.526,42,36.994c0-0.552-0.448-1-1-1   c-0.532,0-0.956,0.418-0.988,0.942l-1.953-1.953C38.582,34.95,39,34.526,39,33.994c0-0.552-0.448-1-1-1   c-0.532,0-0.956,0.418-0.988,0.942l-0.941-0.942H38H44z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,0l-1.068,0.072C12.269,1.141,0,14.283,0,29.994c0,16.542,13.458,30,30,30c6.927,0,13.687-2.425,19.037-6.826l0.851-0.7   L29,31.58V0z M46.899,52.308C42.054,55.982,36.096,57.994,30,57.994c-15.439,0-28-12.561-28-28C2,15.69,12.896,3.667,27,2.161   v30.247L46.899,52.308z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 3.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 9.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 6.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 6.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 9.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 9.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 12.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 12.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 12.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 18.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 15.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 21.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 15.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 21.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 18.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 18.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 15.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 15.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 21.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 21.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 24.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 24.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 24.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 24.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 39.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 42.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 36.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 36.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 33.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 33.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 33.994,
    r: 1,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: " #3a444d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.a8948c262d6c8bdaf5f5369757de60e6.svg";
export { ForwardRef as ReactComponent };